export interface storeType {
  name: string
  is_master: number
  merchant_id: number | null
  is_online: number
  country: number | null
  area: number | null
  branch_address: string
  branch_phone: string
  remark: string
  longitude: string
  latitude: string
}

export enum VerifyStatus {
  IS_NONE = 0,
  IS_VERIFYING = 1,
  IS_DONE = 2,
  IS_FAIL = 3
}

export enum VerifyStatusText {
  IS_NONE = '未送審',
  IS_VERIFYING = '送審中',
  IS_DONE = '已同步',
  IS_FAIL = '審核不通過'
}
